import React from "react";
import { Box, Button, Chip, Divider, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "calc(100vh - 64px)",
    padding: theme.spacing(4, 2),
    background: "rgba(15, 23, 42, 0.75)",
    color: "#f8fafc",
  },
  paper: {
    maxWidth: 920,
    margin: "0 auto",
    padding: theme.spacing(4),
    background: "rgba(15, 23, 42, 0.92)",
    border: "1px solid rgba(148, 163, 184, 0.25)",
    borderRadius: 16,
    boxShadow: "0 20px 45px rgba(15, 23, 42, 0.45)",
  },
  eyebrow: {
    color: "#c4b5fd",
    letterSpacing: "0.08em",
    fontWeight: 700,
    textTransform: "uppercase",
    marginBottom: theme.spacing(2),
  },
  title: {
    fontWeight: 700,
    marginBottom: theme.spacing(2),
    lineHeight: 1.2,
  },
  meta: {
    color: "#cbd5e1",
    marginBottom: theme.spacing(3),
  },
  tags: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  tag: {
    color: "#e2e8f0",
    background: "rgba(59, 130, 246, 0.15)",
    border: "1px solid rgba(96, 165, 250, 0.35)",
  },
  paragraph: {
    color: "#e2e8f0",
    lineHeight: 1.8,
    marginBottom: theme.spacing(2.5),
    fontSize: "1.03rem",
  },
  actions: {
    display: "flex",
    gap: theme.spacing(2),
    marginTop: theme.spacing(4),
    flexWrap: "wrap",
  },
  actionButton: {
    borderRadius: 999,
  },
}));

const articleBody = `
  
`;

const Article = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Paper className={classes.paper}>
        <Typography variant="overline" className={classes.eyebrow}>
          Engineering notes
        </Typography>

        <Typography variant="h3" className={classes.title}>
          Building with intent: why thoughtful software feels better to use
        </Typography>

        <Typography variant="body2" className={classes.meta}>
          Published on September 25, 2026 · 6 min read
        </Typography>

        <Box className={classes.tags}>
          <Chip label="Product thinking" className={classes.tag} />
          <Chip label="Software craft" className={classes.tag} />
          <Chip label="UX" className={classes.tag} />
          <Chip label="Engineering" className={classes.tag} />
        </Box>

        <Divider style={{ marginBottom: "1.5rem" }} />

        {articleBody
          .trim()
          .split("\n\n")
          .map((paragraph, index) => (
            <Typography key={index} variant="body1" className={classes.paragraph}>
              {paragraph.trim()}
            </Typography>
          ))}

        <Box className={classes.actions}>
          <Button
            component={Link}
            to="/projects"
            variant="contained"
            color="primary"
            className={classes.actionButton}
          >
            Back to projects
          </Button>
          <Button
            href="https://medium.com/@tzoltan84"
            target="_blank"
            rel="noreferrer"
            variant="outlined"
            color="primary"
            className={classes.actionButton}
          >
            Read on Medium
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default Article;
